import React, { Component } from 'react';
import "./GameInfo.scss"
import { LiveBoard, getFlag } from '../HandleGames';

class GameInfo extends Component {
    constructor() {
        super();
        this.state = {
            board: [],
            isEnded: false,
            isLoaded: false
        }
    }
    componentWillReceiveProps(nextProps) {
        const _liveData = LiveBoard(nextProps.data)[0];
        if (_liveData) {
            if (_liveData.currentGame) {
                this.setState({
                    board: _liveData.currentGame,
                    isEnded: (_liveData.currentGame.cur_minutes ? _liveData.currentGame.cur_minutes.indexOf("הסתיים") > -1 : false),
                    isLoaded: true
                })
                if ((_liveData.nextGame.gameDate != _liveData.currentGame.gameDate &&
                    _liveData.nextGame.time_start != _liveData.currentGame.time_start &&
                    (_liveData.currentGame.cur_minutes && _liveData.currentGame.cur_minutes.indexOf("הסתיים") > -1) &&
                    _liveData.nextGame) || _liveData.currentGame == null
                ) {
                    this.setState({
                        board: _liveData.nextGame,
                        isEnded: true,
                        isLoaded: true
                    })
                }
            }
            if (_liveData.currentGame == null && _liveData.nextGame) {
                this.setState({
                    board: _liveData.nextGame,
                    isEnded: true,
                    isLoaded: true
                })
            }
        }
    }
    render() {
        if (!this.state.isLoaded) {
            return (
                <div className="gameinfo">
                    <div className="game-container">
                    </div>
                </div>)
        }
        return (
            <div className="gameinfo">
                <div className="game-container">
                    <div className="data">
                        <div className="team">
                            <div className={`flag flag-${getFlag(this.state.board.flagCountryA)}`}></div>
                            <div className="team-name">
                                {this.state.board.countryA}
                            </div>
                        </div>
                        <div className="desc">
                            <div className="house">
                                {this.state.board.levelType}
                            </div>
                            <div className="score">
                                {this.state.board.result}
                            </div>
                        </div>
                        <div className="team">
                            <div className={`flag flag-${getFlag(this.state.board.flagCountryB)}`}></div>
                            <div className="team-name">
                                {this.state.board.countryB}
                            </div>
                        </div>
                    </div>
                    <div className="info-separator"></div>
                    <div className="live">
                        <div className={`pulse ${this.state.isEnded ? "red" : "green"}`}></div>
                        <div className="text">
                            {this.state.isEnded ? (this.state.board.result ? "הסתיים" : "טרם התחיל") : <div>
                                שידור {this.state.board.cur_minutes}
                            </div>}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default GameInfo;



// WEBPACK FOOTER //
// ./src/Components/NextGame/GameInfo/GameInfo.jsx